// GENERATED FILE – DO NOT EDIT BY HAND.
// Source: specs/project-requirements via @pericles/generator v0.
// Mapping from DSL entities to Prisma delegates.
import type { PrismaClient } from "@prisma/client";

export type GeneratedEntityKey =
  | "customer"
  | "customerMember"
  | "project"
  | "projectBrief"
  | "requirement"
  | "specsection"
  | "specsource"
  | "checklistItem"
  | "roadmapProject"
  | "roadmapRoadmapSuggestion"
  | "roadmapProjectAnalysisFields"
  | "roadmapQualityAuditReport"
  | "roadmapQualityGateOverride"
  | "roadmapReviewFieldConfig"
  | "roadmapScoringRoleMember"
  | "roadmapProjectSynthesis"
  | "roadmapAirtableSettings"
  | "roadmapProcess"
  | "roadmapUseCase"
  | "roadmapProjectMember"
  | "roadmapProcessUseCase";

export type GeneratedEntityField = {
  name: string;
  prismaType: string;
  isList: boolean;
  isRequired: boolean;
  defaultValue?: unknown;
};

type DelegateFactory = (prisma: PrismaClient) => unknown;

type GeneratedEntityEntry = {
  delegate: DelegateFactory;
  fields: GeneratedEntityField[];
  allowedFilters?: string[];
};

export const generatedEntityConfig: Record<GeneratedEntityKey, GeneratedEntityEntry> = {
  customer: {
    delegate: (prisma) => prisma.customer,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "name", prismaType: "String", isList: false, isRequired: true },
      { name: "code", prismaType: "String", isList: false, isRequired: true },
      { name: "sector", prismaType: "CustomerSector", isList: false, isRequired: true },
      { name: "countryCode", prismaType: "String", isList: false, isRequired: false },
      { name: "context", prismaType: "String", isList: false, isRequired: false },
      { name: "contextSources", prismaType: "Json", isList: false, isRequired: false },
      { name: "contextGeneratedAt", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "contextGeneratedBy", prismaType: "String", isList: false, isRequired: false },
      { name: "contextGenerationStatus", prismaType: "CustomerContextGenerationStatus", isList: false, isRequired: true, defaultValue: "idle" },
      { name: "contextGenerationError", prismaType: "String", isList: false, isRequired: false },
      { name: "members", prismaType: "CustomerMember", isList: true, isRequired: true },
      { name: "projects", prismaType: "Project", isList: true, isRequired: true },
      { name: "roadmapProjects", prismaType: "RoadmapProject", isList: true, isRequired: true },
      { name: "roadmapProjectMembers", prismaType: "RoadmapProjectMember", isList: true, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  customerMember: {
    delegate: (prisma) => prisma.customerMember,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "customer", prismaType: "Customer", isList: false, isRequired: true },
      { name: "customerId", prismaType: "String", isList: false, isRequired: true },
      { name: "user", prismaType: "User", isList: false, isRequired: true },
      { name: "userId", prismaType: "String", isList: false, isRequired: true },
      { name: "role", prismaType: "CustomerRole", isList: false, isRequired: true, defaultValue: "VIEWER" },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  project: {
    delegate: (prisma) => prisma.project,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "customer", prismaType: "Customer", isList: false, isRequired: true },
      { name: "name", prismaType: "String", isList: false, isRequired: true },
      { name: "code", prismaType: "String", isList: false, isRequired: true },
      { name: "status", prismaType: "ProjectStatus", isList: false, isRequired: true },
      { name: "context", prismaType: "String", isList: false, isRequired: false },
      { name: "contextSources", prismaType: "Json", isList: false, isRequired: false },
      { name: "contextGeneratedAt", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "contextGeneratedBy", prismaType: "String", isList: false, isRequired: false },
      { name: "contextGenerationStatus", prismaType: "ProjectContextGenerationStatus", isList: false, isRequired: true, defaultValue: "idle" },
      { name: "contextGenerationError", prismaType: "String", isList: false, isRequired: false },
      { name: "preDiscoveryQuestions", prismaType: "Json", isList: false, isRequired: false },
      { name: "preDiscoveryQuestionsGeneratedAt", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "preDiscoveryQuestionsGeneratedBy", prismaType: "String", isList: false, isRequired: false },
      { name: "preDiscoveryQuestionsStatus", prismaType: "ProjectContextGenerationStatus", isList: false, isRequired: true, defaultValue: "idle" },
      { name: "preDiscoveryQuestionsError", prismaType: "String", isList: false, isRequired: false },
      { name: "startDate", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "endDate", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "requirements", prismaType: "Requirement", isList: true, isRequired: true },
      { name: "checklistItems", prismaType: "ChecklistItem", isList: true, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  projectBrief: {
    delegate: (prisma) => prisma.projectBrief,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "Project", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "status", prismaType: "ProjectBriefStatus", isList: false, isRequired: true },
      { name: "content", prismaType: "Json", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  requirement: {
    delegate: (prisma) => prisma.requirement,
    allowedFilters: ["projectId","reviewStatus","generationRequested","generationStatus","customerId"],
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "Project", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "title", prismaType: "String", isList: false, isRequired: true },
      { name: "description", prismaType: "String", isList: false, isRequired: true },
      { name: "sourceType", prismaType: "RequirementSourceType", isList: false, isRequired: true, defaultValue: "manual" },
      { name: "sourceMeetingId", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceMeetingQuestionId", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceDraftKey", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceFileName", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceFileId", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewStatus", prismaType: "RequirementReviewStatus", isList: false, isRequired: true },
      { name: "aiReviewStatus", prismaType: "AiReviewStatus", isList: false, isRequired: true },
      { name: "generationRequested", prismaType: "Boolean", isList: false, isRequired: true },
      { name: "generationStatus", prismaType: "ExecutionStatus", isList: false, isRequired: true, defaultValue: "not_requested" },
      { name: "generationTarget", prismaType: "RequirementGenerationTarget", isList: false, isRequired: true },
      { name: "generatedSummary", prismaType: "String", isList: false, isRequired: false },
      { name: "generatedArtifacts", prismaType: "String", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  specsection: {
    delegate: (prisma) => prisma.specSection,
    allowedFilters: ["projectId"],
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "specSource", prismaType: "SpecSource", isList: false, isRequired: true },
      { name: "project", prismaType: "Project", isList: false, isRequired: true },
      { name: "specSourceId", prismaType: "String", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "title", prismaType: "String", isList: false, isRequired: true },
      { name: "content", prismaType: "String", isList: false, isRequired: true },
      { name: "sourceMeetingId", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceMeetingQuestionId", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceDraftKey", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewStatus", prismaType: "RequirementReviewStatus", isList: false, isRequired: true, defaultValue: "pending_review" },
      { name: "aiReviewStatus", prismaType: "AiReviewStatus", isList: false, isRequired: true, defaultValue: "not_applicable" },
      { name: "relatedRequirementIds", prismaType: "Json", isList: false, isRequired: false },
      { name: "relatedChecklistItemIds", prismaType: "Json", isList: false, isRequired: false },
      { name: "relatedWorkItemIds", prismaType: "Json", isList: false, isRequired: false },
      { name: "relatedMeetingIds", prismaType: "Json", isList: false, isRequired: false },
      { name: "relatedAiArtifactIds", prismaType: "Json", isList: false, isRequired: false },
      { name: "level", prismaType: "Int", isList: false, isRequired: false },
      { name: "sequence", prismaType: "Int", isList: false, isRequired: false },
      { name: "dslKind", prismaType: "SpecSectionDslKind", isList: false, isRequired: false },
      { name: "dslStatus", prismaType: "SpecSectionDslStatus", isList: false, isRequired: true },
      { name: "dslCandidates", prismaType: "Json", isList: false, isRequired: false },
      { name: "dslAccepted", prismaType: "Json", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  specsource: {
    delegate: (prisma) => prisma.specSource,
    allowedFilters: ["projectId"],
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "Project", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "name", prismaType: "String", isList: false, isRequired: true },
      { name: "description", prismaType: "String", isList: false, isRequired: false },
      { name: "sourceType", prismaType: "String", isList: false, isRequired: true },
      { name: "uri", prismaType: "String", isList: false, isRequired: false },
      { name: "documentId", prismaType: "String", isList: false, isRequired: false },
      { name: "sections", prismaType: "SpecSection", isList: true, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  checklistItem: {
    delegate: (prisma) => prisma.checklistItem,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "Project", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "title", prismaType: "String", isList: false, isRequired: true },
      { name: "description", prismaType: "String", isList: false, isRequired: false },
      { name: "status", prismaType: "ExecutionStatus", isList: false, isRequired: true, defaultValue: "planned" },
      { name: "owner", prismaType: "String", isList: false, isRequired: false },
      { name: "dueDate", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true, defaultValue: "now()" },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProject: {
    delegate: (prisma) => prisma.roadmapProject,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "customer", prismaType: "Customer", isList: false, isRequired: true },
      { name: "customerId", prismaType: "String", isList: false, isRequired: true },
      { name: "name", prismaType: "String", isList: false, isRequired: true },
      { name: "finalReviewStatus", prismaType: "String", isList: false, isRequired: false },
      { name: "finalReviewNotes", prismaType: "String", isList: false, isRequired: false },
      { name: "settings", prismaType: "RoadmapAirtableSettings", isList: true, isRequired: true },
      { name: "processes", prismaType: "RoadmapProcess", isList: true, isRequired: true },
      { name: "useCases", prismaType: "RoadmapUseCase", isList: true, isRequired: true },
      { name: "processUseCases", prismaType: "RoadmapProcessUseCase", isList: true, isRequired: true },
      { name: "qualityAuditReports", prismaType: "RoadmapQualityAuditReport", isList: true, isRequired: true },
      { name: "qualityGateOverrides", prismaType: "RoadmapQualityGateOverride", isList: true, isRequired: true },
      { name: "reviewFieldConfigs", prismaType: "RoadmapReviewFieldConfig", isList: true, isRequired: true },
      { name: "scoringRoleMembers", prismaType: "RoadmapScoringRoleMember", isList: true, isRequired: true },
      { name: "synthesisReports", prismaType: "RoadmapProjectSynthesis", isList: true, isRequired: true },
      { name: "members", prismaType: "RoadmapProjectMember", isList: true, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapRoadmapSuggestion: {
    delegate: (prisma) => prisma.roadmapRoadmapSuggestion,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "approvals", prismaType: "Json", isList: false, isRequired: false },
      { name: "auditLog", prismaType: "Json", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "generatedByUserId", prismaType: "String", isList: false, isRequired: false },
      { name: "inputsHash", prismaType: "String", isList: false, isRequired: true },
      { name: "lastEditedByUserId", prismaType: "String", isList: false, isRequired: false },
      { name: "paramsJson", prismaType: "Json", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "revision", prismaType: "Float", isList: false, isRequired: true, defaultValue: 1 },
      { name: "status", prismaType: "RoadmapSuggestionStatus", isList: false, isRequired: true, defaultValue: "DRAFT" },
      { name: "stopReason", prismaType: "String", isList: false, isRequired: true },
      { name: "suggestionJson", prismaType: "Json", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProjectAnalysisFields: {
    delegate: (prisma) => prisma.roadmapProjectAnalysisFields,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "processFields", prismaType: "Json", isList: false, isRequired: true },
      { name: "useCaseFields", prismaType: "Json", isList: false, isRequired: true },
      { name: "includeRawFields", prismaType: "Boolean", isList: false, isRequired: true, defaultValue: true },
      { name: "processRawFields", prismaType: "Json", isList: false, isRequired: false },
      { name: "useCaseRawFields", prismaType: "Json", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapQualityAuditReport: {
    delegate: (prisma) => prisma.roadmapQualityAuditReport,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "qualityGateOverrides", prismaType: "RoadmapQualityGateOverride", isList: true, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "inputsHash", prismaType: "String", isList: false, isRequired: true },
      { name: "stopReason", prismaType: "String", isList: false, isRequired: true },
      { name: "report", prismaType: "Json", isList: false, isRequired: true },
      { name: "evidenceManifest", prismaType: "Json", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapQualityGateOverride: {
    delegate: (prisma) => prisma.roadmapQualityGateOverride,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "report", prismaType: "RoadmapQualityAuditReport", isList: false, isRequired: false },
      { name: "reportId", prismaType: "String", isList: false, isRequired: false },
      { name: "reason", prismaType: "String", isList: false, isRequired: true },
      { name: "snapshotJson", prismaType: "Json", isList: false, isRequired: true },
      { name: "forcePass", prismaType: "Boolean", isList: false, isRequired: true, defaultValue: true },
      { name: "createdByUserId", prismaType: "String", isList: false, isRequired: false },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapReviewFieldConfig: {
    delegate: (prisma) => prisma.roadmapReviewFieldConfig,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "scope", prismaType: "String", isList: false, isRequired: true },
      { name: "fieldsOrder", prismaType: "Json", isList: false, isRequired: true },
      { name: "enabledFields", prismaType: "Json", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "updatedByUserId", prismaType: "String", isList: false, isRequired: false },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapScoringRoleMember: {
    delegate: (prisma) => prisma.roadmapScoringRoleMember,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "scoringRole", prismaType: "String", isList: false, isRequired: true },
      { name: "user", prismaType: "User", isList: false, isRequired: true },
      { name: "userId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdByUserId", prismaType: "String", isList: false, isRequired: false },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProjectSynthesis: {
    delegate: (prisma) => prisma.roadmapProjectSynthesis,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "inputsHash", prismaType: "String", isList: false, isRequired: true },
      { name: "stopReason", prismaType: "String", isList: false, isRequired: true },
      { name: "synthesis", prismaType: "Json", isList: false, isRequired: true },
      { name: "evidenceManifest", prismaType: "Json", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapAirtableSettings: {
    delegate: (prisma) => prisma.roadmapAirtableSettings,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "baseId", prismaType: "String", isList: false, isRequired: true },
      { name: "apiToken", prismaType: "String", isList: false, isRequired: true },
      { name: "usersTable", prismaType: "String", isList: false, isRequired: false },
      { name: "usersView", prismaType: "String", isList: false, isRequired: false },
      { name: "appsTable", prismaType: "String", isList: false, isRequired: false },
      { name: "appsView", prismaType: "String", isList: false, isRequired: false },
      { name: "integrationsTable", prismaType: "String", isList: false, isRequired: false },
      { name: "integrationsView", prismaType: "String", isList: false, isRequired: false },
      { name: "technicalAssessmentsTable", prismaType: "String", isList: false, isRequired: false },
      { name: "technicalAssessmentsView", prismaType: "String", isList: false, isRequired: false },
      { name: "dataRiskChecklistsTable", prismaType: "String", isList: false, isRequired: false },
      { name: "dataRiskChecklistsView", prismaType: "String", isList: false, isRequired: false },
      { name: "processesTable", prismaType: "String", isList: false, isRequired: true },
      { name: "processesView", prismaType: "String", isList: false, isRequired: false },
      { name: "useCasesTable", prismaType: "String", isList: false, isRequired: true },
      { name: "useCasesView", prismaType: "String", isList: false, isRequired: false },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProcess: {
    delegate: (prisma) => prisma.roadmapProcess,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "airtableBaseId", prismaType: "String", isList: false, isRequired: false },
      { name: "airtableRecordId", prismaType: "String", isList: false, isRequired: false },
      { name: "airtableTableName", prismaType: "String", isList: false, isRequired: false },
      { name: "matchKey", prismaType: "String", isList: false, isRequired: false },
      { name: "name", prismaType: "String", isList: false, isRequired: false },
      { name: "raw", prismaType: "Json", isList: false, isRequired: false },
      { name: "reviewOwner", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewNotes", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewStatus", prismaType: "String", isList: false, isRequired: false },
      { name: "processUseCases", prismaType: "RoadmapProcessUseCase", isList: true, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapUseCase: {
    delegate: (prisma) => prisma.roadmapUseCase,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "airtableBaseId", prismaType: "String", isList: false, isRequired: false },
      { name: "airtableRecordId", prismaType: "String", isList: false, isRequired: false },
      { name: "airtableTableName", prismaType: "String", isList: false, isRequired: false },
      { name: "feasibility", prismaType: "Float", isList: false, isRequired: false },
      { name: "impact", prismaType: "Float", isList: false, isRequired: false },
      { name: "linkedProcessKey", prismaType: "String", isList: false, isRequired: false },
      { name: "name", prismaType: "String", isList: false, isRequired: false },
      { name: "opportunityScore", prismaType: "Float", isList: false, isRequired: false },
      { name: "raw", prismaType: "Json", isList: false, isRequired: false },
      { name: "reviewOwner", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewNotes", prismaType: "String", isList: false, isRequired: false },
      { name: "reviewStatus", prismaType: "String", isList: false, isRequired: false },
      { name: "jarvisExportStatus", prismaType: "String", isList: false, isRequired: false },
      { name: "jarvisExportError", prismaType: "String", isList: false, isRequired: false },
      { name: "jarvisExportedAt", prismaType: "DateTime", isList: false, isRequired: false },
      { name: "risk", prismaType: "Float", isList: false, isRequired: false },
      { name: "useCaseProcesses", prismaType: "RoadmapProcessUseCase", isList: true, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProjectMember: {
    delegate: (prisma) => prisma.roadmapProjectMember,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "customer", prismaType: "Customer", isList: false, isRequired: true },
      { name: "customerId", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "role", prismaType: "RoadmapProjectRole", isList: false, isRequired: true, defaultValue: "VIEWER" },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "user", prismaType: "User", isList: false, isRequired: true },
      { name: "userId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
  roadmapProcessUseCase: {
    delegate: (prisma) => prisma.roadmapProcessUseCase,
    fields: [
      { name: "id", prismaType: "String", isList: false, isRequired: true },
      { name: "process", prismaType: "RoadmapProcess", isList: false, isRequired: true },
      { name: "processId", prismaType: "String", isList: false, isRequired: true },
      { name: "project", prismaType: "RoadmapProject", isList: false, isRequired: true },
      { name: "projectId", prismaType: "String", isList: false, isRequired: true },
      { name: "tenant", prismaType: "Tenant", isList: false, isRequired: true },
      { name: "tenantId", prismaType: "String", isList: false, isRequired: true },
      { name: "useCase", prismaType: "RoadmapUseCase", isList: false, isRequired: true },
      { name: "useCaseId", prismaType: "String", isList: false, isRequired: true },
      { name: "createdAt", prismaType: "DateTime", isList: false, isRequired: true },
      { name: "updatedAt", prismaType: "DateTime", isList: false, isRequired: true },
    ],
  },
};
